import {
  FaReact, FaPython, FaJava, FaPhp, FaJsSquare, FaDatabase, FaNodeJs, FaCode
} from 'react-icons/fa';
import {
  SiTailwindcss, SiCplusplus, SiDart, SiLinux, SiDocker, SiPostman,
  SiGithub, SiJunit5, SiJest, SiSlack,
  SiWebpack, SiMarkdown, SiJavascript,
  SiAndroidstudio
} from 'react-icons/si';

const educationData = [
  {
    degree: "Bachelor of Computer Science",
    school: "Colorado State University",
    location: "Fort Collins, CO",
    duration: "Jan 2023 – Dec 2024",
    tasks: [
      "Focused on core areas such as algorithms, full-stack development, and system security.",
      "Completed Agile-based team projects involving frontend, backend, and REST API development.",
      "Applied Clean Code principles, TDD, CI/CD, and collaborative tools like GitHub, ZenHub, and Code Climate."
    ],
    tech: [
      // Languages & Frameworks
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "Java", icon: FaJava, color: "bg-[#f97316]" },
      { name: "JavaScript", icon: SiJavascript, color: "bg-[#facc15]" },
      { name: "Python", icon: FaPython, color: "bg-[#4b5563]" },
      { name: "C++", icon: SiCplusplus, color: "bg-[#2563eb]" },
      { name: "MySQL", icon: FaDatabase, color: "bg-[#64748b]" },
      { name: "Tailwind CSS", icon: SiTailwindcss, color: "bg-[#0ea5e9]" },

      // Tools
      { name: "GitHub", icon: SiGithub, color: "bg-[#171515]" },
      { name: "Postman", icon: SiPostman, color: "bg-[#ff6c37]" },
      { name: "JUnit", icon: SiJunit5, color: "bg-[#34d399]" },
      { name: "Jest", icon: SiJest, color: "bg-[#991b1b]" },
      { name: "Docker", icon: SiDocker, color: "bg-[#0db7ed]" },
      { name: "Linux", icon: SiLinux, color: "bg-[#111827]" },
      { name: "Slack", icon: SiSlack, color: "bg-[#4f46e5]" },
      { name: "ZenHub", icon: null, color: "bg-[#3b82f6]" },
      { name: "Code Climate", icon: null, color: "bg-[#1e3a8a]" },
      { name: "VS Code", icon: FaCode, color: "bg-[#2563eb]" },
      { name: "Markdown", icon: SiMarkdown, color: "bg-[#4b5563]" },
      { name: "Maven", icon: FaCode, color: "bg-[#ea580c]" },
      { name: "Webpack", icon: SiWebpack, color: "bg-[#60a5fa]" },
      { name: "Node.js", icon: FaNodeJs, color: "bg-[#3b82f6]" },

      // Concepts
      { name: "Clean Code", icon: null, color: "bg-[#334155]" },
      { name: "TDD", icon: null, color: "bg-[#4b5563]" },
      { name: "CI/CD", icon: null, color: "bg-[#1e293b]" },
      { name: "REST API", icon: null, color: "bg-[#6b7280]" },
      { name: "Concurrency", icon: null, color: "bg-[#475569]" },
      { name: "OOP", icon: null, color: "bg-[#64748b]" },
      { name: "Web Dev", icon: null, color: "bg-[#1e293b]" },
      { name: "Agile", icon: null, color: "bg-[#10b981]" }
    ]
  },
  {
    degree: "AAS Software Engineering",
    school: "Oakland Community College",
    location: "Auburn Hills, MI",
    duration: "Jan 2020 – Dec 2022",
    tasks: [
      "Completed coursework in OOP with Java and C++, database systems, and Android mobile app development.",
      "Built foundational knowledge in web systems using PHP and JavaScript.",
      "Engaged in real-world capstone projects and UML-based software design."
    ],
    tech: [
      { name: "Java", icon: FaJava, color: "bg-[#f97316]" },
      { name: "C++", icon: SiCplusplus, color: "bg-[#2563eb]" },
      { name: "PHP", icon: FaPhp, color: "bg-[#6b7280]" },
      { name: "JavaScript", icon: FaJsSquare, color: "bg-[#facc15]" },
      { name: "MySQL", icon: FaDatabase, color: "bg-[#64748b]" },
      { name: "Dart", icon: SiDart, color: "bg-[#38bdf8]" },
      { name: "UML", icon: null, color: "bg-[#334155]" },
      { name: "Mobile Dev", icon: null, color: "bg-[#1e293b]" },
      { name: "Android Studio", icon: SiAndroidstudio, color: "bg-[#10b981]" },
      { name: "Web Dev", icon: null, color: "bg-[#1e293b]" },
      { name: "System Analysis", icon: null, color: "bg-[#475569]" }
    ]
  }
];

export default educationData;
